import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        if (window.getCookie('av')) {
            this.element.classList.add('hidden');
        }
    }
    disconnect() {
        this.element.classList.remove('hidden');
    }

    confirmAge(e) {
        e.preventDefault();
        e.stopPropagation();
        window.setCookie('av', true, 60, '/', '', 'None', false, true);
        this.element.classList.add('hidden');
    }
}
